/* eslint-disable react/no-danger, react/no-unescaped-entities, max-len */
import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import track from 'react-tracking';
import { Container } from '@edx/paragon';
import CloudflareImage from '@prospectus/common/ui/CloudflareImage';
import ProgramDataBarDetails from './components/ProgramDataBarDetails';
import ProgramDataBarButton from './components/ProgramDataBarButton';

const logoWidth = 200;
const logoHeight = 100;

export function BaseProgramDataBar(props) {
  const {
    title,
    type,
    authoringOrganizations: owners,
    isBundled,
    subscriptionDetails,
  } = props;

  const { isSubscriptionEnabled } = subscriptionDetails;

  return (
    <div
      className={classNames('data-bar', 'shadow')}
    >
      <div className={classNames('data-bar-content', `partner-count-${owners.length}`)}>
        <Container size="lg">
          <div className="row">
            <div className="partner-image-wrapper">
              {owners.map(({ logoImageUrl: imgUrl, name, key }) => (
                <div className="partner" key={key}>
                  <CloudflareImage
                    className="partner-logo"
                    title={name}
                    url={imgUrl}
                    width={logoWidth}
                    height={logoHeight}
                    additionalParams={{
                      quality: 100,
                    }}
                  />
                </div>
              ))}
            </div>
            <ProgramDataBarDetails
              type={type}
              title={title}
              owners={owners}
            />
            {isBundled
                && (
                  <div className="cta-wrapper">
                    <ProgramDataBarButton
                      isSubscriptionEnabled={isSubscriptionEnabled}
                      {...props}
                    />
                  </div>
                )}
          </div>
        </Container>
      </div>
    </div>
  );
}

BaseProgramDataBar.propTypes = {
  uuid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  authoringOrganizations: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    key: PropTypes.string,
    logoImageUrl: PropTypes.string,
  })).isRequired,
  subscriptionDetails: PropTypes.shape({
    isSubscriptionEnabled: PropTypes.bool,
  }).isRequired,
  enrollButtonId: PropTypes.string.isRequired,
  isBundled: PropTypes.bool.isRequired,
  tracking: PropTypes.shape(),
  courseFocusId: PropTypes.string,
  enrollFocus: PropTypes.bool,
  webview: PropTypes.bool,
};

BaseProgramDataBar.defaultProps = {
  tracking: {},
  courseFocusId: '',
  enrollFocus: true,
  webview: false,
};

export default track({
  component: 'program-data-bar',
})(BaseProgramDataBar);
